import { NotFound, ProtectedRoute } from "../shared/pages";

export const fallbackRoutes = [
    {
        element: <ProtectedRoute />,
        children: [
            {
                element: <ProtectedRoute />,
                children: [{ path: '/', element: <ProtectedRoute /> }],
            },
            {
                element: <NotFound />,
                children: [{ path: '*', element: <NotFound /> }],
            }
        ]
    }
];